import IETBHEC27_Sponsorship from '../assets/IETBHEC27_Sponsorship_Final.pdf'
import { useState } from "react";
import S0 from '../assets/images/San Jose State University.jpg'
import S3 from '../assets/images/Logo_HCM-UTE.png'
// import Arun from '../assets/images/vice_chancellor_img.jpg'
// import Alex from '../assets/images/Alex Stojcevski.jpg'
import CurtinLogo from '../assets/images/Curtin Singapore logo - keyline.jpg'
import APAQA from '../assets/images/APAQA_Logo.png'

function SponsorshipExhibition() {
    const [showSponsorTable, setShowSponsorTable] = useState(false);
    return (
        <div>
            <h2>Sponsorship and Exhibition</h2>
            <p>IETBHEC’27 is the fifth conference in the IETEC series and will be held in vibrant, beautiful Da Nang, Vietnam, between 25-27 February 2027. IETBHEC'27 will provide opportunities for all stakeholders from around the globe to explore the education outcomes, issues, and strategies needed to meet todays and tomorrow’s challenges, particularly in engineering, technology, business and health education.</p>
            <p>A range of sponsorship opportunities are now available for the conference, offering valuable exposure to industry leaders, policy makers, educationalists and professionals. You can showcase your brand at IETBHEC’27, a popular gathering of educators from around the globe. </p>
            <div className="sponsor-section">
                <button
                    type="button"
                    className="btn btn-outline-primary"
                    onClick={() => setShowSponsorTable(!showSponsorTable)}
                >
                    {showSponsorTable
                        ? "▼ Hide Sponsorship Fees"
                        : "▶ View Sponsorship Fees"}
                </button>

                {showSponsorTable && (
                    <table className="table table-bordered sponsor-table mt-3">
                        <thead>
                            <tr>
                                <th>Sponsorship Package</th>
                                <th>Fee (AUD)</th>
                                <th>Fee (VND)</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr>
                                <td>Corporate Sponsor</td>
                                <td>10,000</td>
                                <td>185,000,000</td>
                            </tr>

                            <tr>
                                <td>Platinum Sponsor</td>
                                <td>8,000</td>
                                <td>150,000,000</td>
                            </tr>

                            <tr>
                                <td>Gold Sponsor</td>
                                <td>5,000</td>
                                <td>90,000,000</td>
                            </tr>

                            <tr>
                                <td>Silver Sponsor</td>
                                <td>3,000</td>
                                <td>50,000,000</td>
                            </tr>

                            <tr>
                                <td>Banquet/Dinner Sponsor</td>
                                <td>3,000</td>
                                <td>50,000,000</td>
                            </tr>

                            <tr>
                                <td>Exhibition Space</td>
                                <td>1,000</td>
                                <td>18,000,000</td>
                            </tr>
                        </tbody>
                    </table>
                )}
            </div>
            <br></br>
            <p>The IETBHEC’27 sponsorship can also be “unrestricted” contributions and/or ”in-kind” such as printing of conference materials, morning and afternoon tea breaks, lunches and dinners, sponsorship of Gala Banquet, transportation, or any other direct expenses related to the conference organization.</p>
            <p>Contact: <a href="mailto:contact@ietbhec.com" target='_blank' rel="noreferrer noopener">contact@ietbhec.com</a></p>
            <p>Sponsorship Detail: <a href={IETBHEC27_Sponsorship} target='_blank' rel="noreferrer noopener">IETBHEC27_Sponsorship.pdf</a></p>

            <section className="sponsor-strip">
                <h4>Proudly supported by</h4>

                <div className="sponsor-strip-logos">
                    <img src={S0} alt="" />
                    <img src={S3} alt="" />
                    <img src={CurtinLogo} alt="" />
                    <img src={APAQA} alt="" />
                </div>
            </section>
        </div>
    )
}

export default SponsorshipExhibition